<template>
  <div ref="dropzone" class="dropzone" :class="{ hidden: !dropzoneVisible }">
    <div class="dropzone__inner">
      Drag and Drop
      <br />
      Your Files Anywhere
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { isArtworkWithError } from "./utils";
import { useDtfStore } from "./store";
import { useSpanglesStore } from "./spangles-module";

export default {
  name: "DropZone",
  data() {
    return {
      dropzoneVisible: false
    };
  },
  computed: {
    ...mapState(useDtfStore, ["artworks", "showModal", "isSpangle", "isPuff", "isStickerSample"]),
    ...mapState(useSpanglesStore, ["spanglesMaxImageCount"]),
    metadata() {
      const { removeBackground, metadata, withBgMetadata } = this.artwork || {};

      // if the image already comes with transparency
      if (!withBgMetadata) {
        return metadata;
      }

      // otherwise, check for the flag for the switch, metadata will be image with background
      return removeBackground ? metadata : withBgMetadata;
    },
    withErrors() {
      return this.metadata.errors?.length > 0 && !this.showModal;
    }
  },
  methods: {
    ...mapActions(useDtfStore, ["addFilesToQueue"]),
    ...mapActions(useDtfStore, ["removeArtworkByIndex", "setReplaceArtwork"]),
    handleDrop(e) {
      this.hideDropzone(e);
      const { files } = e.dataTransfer;
      const userArtworks = this.artworks.filter(artwork => !artwork.isSimulated);
      let artworkIndex = null;

      if (
        files.length > 10 ||
        (this.isSpangle && files.length > this.spanglesMaxImageCount) ||
        ((this.isPuff || this.isStickerSample) && (userArtworks.length > 0 || files.length > 1))
      ) {
        this.showFilesError = true;
        return;
      }

      if (files.length <= 1 && this.replaceArtwork) {
        artworkIndex = 0;
      } else {
        this.artworks.forEach((artwork, index) => {
          if (isArtworkWithError(artwork)) {
            this.removeArtworkByIndex(index);
          }
        });
      }

      this.addFilesToQueue({ files, isDropEvent: true, artworkIndex });
      this.setReplaceArtwork(false);
    },
    hideDropzone(e) {
      e.preventDefault();
      this.dropzoneVisible = false;
    },
    showDropzone(e) {
      e.preventDefault();
      this.dropzoneVisible = true;
    }
  },
  mounted() {
    window.addEventListener("dragenter", this.showDropzone);
    window.addEventListener("dragover", this.showDropzone);
    window.addEventListener("drop", this.handleDrop);
    window.addEventListener("dragleave", this.hideDropzone);
  },
  unmounted() {
    window.removeEventListener("dragenter", this.showDropzone);
    window.removeEventListener("dragover", this.showDropzone);
    window.removeEventListener("drop", this.handleDrop);
    window.removeEventListener("dragleave", this.hideDropzone);
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";

.dropzone {
  background: $white;
  opacity: 0.9;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  z-index: 100;

  &__inner {
    position: absolute;
    top: 30px;
    right: 30px;
    bottom: 30px;
    left: 30px;
    border: 3px dashed $gray-border;
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: $gray-text;
    text-align: center;
  }
}
</style>
